import React, { createContext, useContext, useEffect, useCallback } from 'react';

import { initGTM, sendToGTM, CUSTOM_EVENT_ANALYTICS } from '../services/index';

export type EventParams = {
  [eventProperty: string]: string | number | string[] | number[];
};

export type GTMContextValue = {
  sendCustomEventDataToGTM?: (params: EventParams) => void;
  sendEventDataToGTM?: (params: EventParams) => void;
};

const GTMContext = createContext<GTMContextValue>({});

export function GTMProvider({ children }: { children: JSX.Element }): JSX.Element {
  const sendCustomEventDataToGTM = useCallback((eventInfo) => {
    sendToGTM({ event: CUSTOM_EVENT_ANALYTICS, ...eventInfo });
  }, []);

  const sendEventDataToGTM = useCallback((eventInfo) => {
    sendToGTM(eventInfo);
  }, []);

  useEffect(() => {
    initGTM({
      gtmId: process.env.REACT_APP_GTM_ID,
      environment: process.env.REACT_APP_GTM_ENV,
    });
  }, []);

  return (
    <GTMContext.Provider value={{ sendCustomEventDataToGTM, sendEventDataToGTM }}>
      {children}
    </GTMContext.Provider>
  );
}

export function useGTM(): GTMContextValue {
  const context = useContext(GTMContext);

  if (context === 'undefined') {
    throw new Error('sendDataToGTM precisa ser usado com o GTMProvider');
  }

  const { sendCustomEventDataToGTM, sendEventDataToGTM } = context;

  return { sendCustomEventDataToGTM, sendEventDataToGTM };
}
